import styled from 'styled-components';

export const CenterContainer = styled.div`
  display: flex;
  justify-content: center
`;
